<template>
    <CCardHeader>
        <div>
            <h3 class="mb-2">
                <CIcon name="cilGroup" />
                <span v-if="event.code">
                    {{ event.code }} -
                </span>
                {{ event.name }}

                <CButton color="warning" size="sm" style="color:#fff; margin-left:5px;" @click="$emit('edit-event')">
                    <CIcon name="cil-pencil" />
                </CButton>

                <CBadge v-if="event.has_overcapacity" color="danger" style="margin-left:5px;">
                    SOBRECUPO
                </CBadge>
            </h3>

            <div>
                Fecha:
                <strong>{{ formatFullDate(event.date) }}</strong>
                <br />

                Estado:
                <CBadge :color="statusColor">
                    {{ event.status ? event.status.name : '' }}
                </CBadge>

                <br />

                <template v-if="event.num_tables > 0">
                    N° Mesas: {{ event.num_tables }}
                    <br />
                </template>

                <template v-if="event.external_registration_link">
                    Enlace de registro:
                    <br />
                    <a :href="'/#' + event.external_registration_link" target="_blank" style="word-break: break-all;">
                        {{ event.external_registration_link_full }}
                    </a>
                </template>
            </div>
        </div>
    </CCardHeader>
</template>

<script>
import useDateFormatter from '@/composables/useDateFormatter'

const { formatFullDate } = useDateFormatter()

export default {
    name: 'EventHeader',
    props: {
        event: {
            type: Object,
            required: true
        },
        caption: {
            type: String,
            default: 'Evento'
        }
    },
    computed: {
        statusColor() {
            if (!this.event.status || !this.event.status.code) return 'info'

            switch (this.event.status.code) {
                case 'open':
                    return 'warning'
                case 'done':
                    return 'success'
                case 'canceled':
                    return 'danger'
                default:
                    return 'info'
            }
        }
    },
    methods: {
        formatFullDate(date) {
            return formatFullDate(date)
        }
    }
}
</script>
